var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClosedIncidentsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1553_22301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0C4.71007 0 0 4.48578 0 10C0 15.5142 4.71007 20 10.5 20C16.2899 20 21 15.5142 21 10C21 4.48578 16.2899 0 10.5 0Z",
    fill: "#9BA098"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8217 7.88074L10.1342 13.2973C9.96356 13.4598 9.73958 13.5416 9.51559 13.5416C9.29161 13.5416 9.06763 13.4598 8.897 13.2973L6.0533 10.589C5.71107 10.2632 5.71107 9.73651 6.0533 9.41074C6.39536 9.08481 6.94827 9.08481 7.2905 9.41074L9.51559 11.5299L14.5845 6.70245C14.9266 6.37653 15.4795 6.37653 15.8217 6.70245C16.1638 7.02823 16.1638 7.55481 15.8217 7.88074Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1553_22301"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedIncidentsIcon);
export default __webpack_public_path__ + "static/media/closedIncidentsIcon.f991c883b97e5697fffb32d3c053e92b.svg";
export { ForwardRef as ReactComponent };